<template>
  <div class="chooseInput">
    <div class="chooseHeader" :title="value.desc" @click="toggleList" v-on-clickaway="hideList">
      <input type="text" class="keyWord ellip" disabled="disabled" v-bind:value="value.desc" ref="input"/>
      <div class="chooseIco"></div>
    </div>
    <ul v-if="list.length!=0 && selectShow" @mouseenter="stopScroll" @mouseleave="canedScroll" ref="list" class="list">
      <li class="dot ellip" :key="item.desc" v-for="item in list" @click="selectValueHandle(item)">{{item.desc}}</li>
    </ul>
  </div>
</template>

<script>
  import $ from 'jquery';
  import {directive as onClickaway} from 'vue-clickaway';
  export default {
    directives: {
      onClickaway: onClickaway,
    },
    name: 'Selectc',
    data: function () {
      return {
        canScroll: true,
        selectShow: false
      };
    },
    props: ["value", "list", 'isChange'],

    methods: {
      stopScroll(ev) {
        this.canScroll = false;
      },
      canedScroll() {
        this.canScroll = true;
      },
      selectValueHandle(val) {
        this.selectShow = false; //隐藏下拉框
        this.$refs.input.value = val.desc;
        this.$emit('input', val);
        this.$emit("onSelectChange", val);
      },
      toggleList(){
        if (!this.isChange && !this.selectShow) {
          this.selectShow = true;
        } else if (this.selectShow) {
          this.selectShow = false;
        }
      },
      showList() { // 组件外打开下拉框方法
        //  var ev = event || $event
        //  ev.stopPropagation()
        if (!this.isChange) {
          setTimeout(() => {
            this.selectShow = true;
          })
        }
      },
      hideList() {
        this.selectShow = false;
      }
    }
  }
</script>

<style scoped lang="sass">
  .chooseInput
    position: relative
    width: 100%
    height: 100%
    box-sizing: border-box


  .chooseHeader
    box-sizing: border-box
    position: absolute
    top: 0px
    left: 0
    width: 100%
    height: 100%
    cursor: pointer


  .chooseHeader input
    box-sizing: border-box
    vertical-align: top
    padding-right: 30px
    width: 100%
    height: 100%
    border: none
    text-align: center
    text-indent: 30px
    font-size: 16px
    cursor: pointer
    pointer-events: none


  .chooseIco
    position: absolute
    top: 50%
    right: 19px
    margin-top: -4px
    width: 11px
    height: 8px
    background: url("../assets/images/topbg_s.png") no-repeat


  .list
    box-sizing: border-box
    position: absolute
    top: 51px
    left: -1px
    width: 100%
    background: #fff
    z-index: 99
    overflow: auto
    max-height: 170px
    cursor: pointer


  .list li
    box-sizing: border-box
    height: 44px
    width: 100%
    text-align: center
    line-height: 44px
    font-size: 16px


  .list li:hover
    background: #f1f1f1


  input:disabled
    color: #333
    border: none !important
    background: #fff !important
    user-select: none
    -ms-user-select: none


  .border ul
    box-sizing: content-box
    border: 1px solid #eee
    top: 42px

  .small ul
    top: 38px


  .small .chooseHeader input
    font-size: 16px
    text-indent: 9px

  .small .chooseHeader input, .small ul li
    text-align: left
    text-indent: 18px


  .small .chooseIco
    top: 18px

  .multi .chooseIco
    top: 16px
    right: 10px

  .multi ul
    box-sizing: content-box
    top: 30px
    border: 1px solid #d2d2d2

  .multi ul li
    height: 30px
    line-height: 30px
    font-size: 16px

  .multi .chooseHeader input
    font-size: 16px
    text-indent: 3px
    padding-right: 25px

  .multiMax .chooseHeader input
    font-size: 16px
    text-indent: 25px
    padding-right: 25px

  .indexSearch .chooseHeader input, .indexSearch ul li
    text-align: left
    text-indent: 23px

  .indexSearch .list
    background: #f5f5f5

  .indexSearch .list li:hover
    background: #e0e0e0

  .platform_select ul
    top: 40px
    border: 1px solid #d2d2d2

  .indexLocation .chooseHeader input
    text-indent: 24px

  .indexLocation .chooseHeader .chooseIco
    margin-top: -3px

</style>
